import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaEnvelope, FaPaperPlane, FaCheckCircle } from "react-icons/fa";
import Logo from "../../components/Logo";

const EmailVerificationSent = () => {
  const location = useLocation();
  const { email, fullName } = location.state || { email: "", fullName: "" };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1 },
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 flex items-center justify-center p-4">
      <motion.div
        className="bg-white rounded-2xl shadow-xl overflow-hidden w-full max-w-md"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="p-8">
          <div className="flex justify-center mb-6">
            <Logo size="large" />
          </div>

          <motion.div className="text-center mb-8" variants={itemVariants}>
            <div className="bg-green-100 p-4 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4">
              <FaEnvelope className="text-green-600 text-3xl" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Vérifiez votre boîte mail
            </h1>
            <p className="text-gray-600">
              Nous avons envoyé un lien de vérification à{" "}
              <span className="font-medium">{email}</span>
            </p>
          </motion.div>

          <motion.div className="space-y-6" variants={itemVariants}>
            <div className="bg-gray-50 rounded-lg p-4 border border-gray-100">
              <h2 className="font-medium text-gray-700 mb-2 flex items-center">
                <FaCheckCircle className="text-green-500 mr-2" />
                Prochaines étapes
              </h2>
              <ol className="list-decimal pl-5 text-gray-600 text-sm space-y-2">
                <li>Ouvrez l'email que nous venons de vous envoyer</li>
                <li>Cliquez sur le bouton ou lien de vérification</li>
                <li>Vous serez redirigé vers la page de connexion</li>
              </ol>
            </div>

            <div className="text-center text-sm text-gray-500">
              <p>
                L'email peut prendre quelques minutes à arriver. Vérifiez
                également votre dossier de spam.
              </p>
            </div>

            <div className="flex flex-col space-y-3">
              <Link
                to="/resend-verification"
                className="w-full py-2 px-4 bg-green-600 hover:bg-green-700 text-white rounded-md text-center transition-colors"
              >
                <span className="flex items-center justify-center">
                  <FaPaperPlane className="mr-2" />
                  Renvoyer l'email de vérification
                </span>
              </Link>

              <Link
                to="/login"
                className="w-full py-2 px-4 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md text-center transition-colors"
              >
                Retour à la connexion
              </Link>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default EmailVerificationSent;
